<template>
  <div>
    <IconButton
      icon="mdi-account"
      :tooltip-text="$t('Techadress.TechInfo')"
      @click="showDialog = true"
    />
    
    <v-dialog v-model="showDialog" max-width="500">
      <v-card>
        <v-card-title>{{ $t('Techadress.TechInfo') }}</v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <p>{{ $t('Techadress.CountAllConnections') }} {{ techadressData.countAllConnections }}</p>
                <p>{{ $t('Techadress.UsersOnline') }} {{ techadressData.usersOnline }}</p>
                <p>{{ $t('Techadress.Threads') }} {{ techadressData.threads }}</p>
                <p>{{ $t('Techadress.RunTime') }} {{ techadressData.runTime }}</p>
                <p>{{ $t('Techadress.ConnectionsPerSecond') }} {{ techadressData.connectionsPerSecond }}</p>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="showDialog = false">
            {{ $t('Close') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IconButton from './IconButton.vue';
import api from '@/AxiosRequests';

export default {
  name: 'TechadressButton',
  components: {
    IconButton
  },
  data() {
    return {
      showDialog: false,
      techadressData: {
        countAllConnections: 0,
        usersOnline: 0,
        threads: 0,
        runTime: '',
        connectionsPerSecond: 0
      },
      techadressInterval: null
    };
  },
  methods: {
    fetchTechadressData() {
      if (!this.showDialog) return;
      api.techAdress.get()
        .then(response => this.techadressData = response.data)
        .catch(error => console.error('There was an error!', error));
    }
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        this.fetchTechadressData();
        this.techadressInterval = setInterval(this.fetchTechadressData, 5000);
      } else {
        if (this.techadressInterval) {
          clearInterval(this.techadressInterval);
          this.techadressInterval = null;
        }
      }
    }
  },
  beforeUnmount() {
    if (this.techadressInterval) {
      clearInterval(this.techadressInterval);
    }
  }
};
</script>
